module.exports = __webpack_public_path__ + "static/img/cochabamba.5133f94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/departamentales/cochabamba.jpg
// module id = Kisa
// module chunks = 1